import elfium from "./elfiumApp";

angular.bootstrap(document.body, [elfium], {strictDi: true});


// WEBPACK FOOTER //
// ./src/app/main.ts